import { Link } from '@solidjs/router';
import { styled } from 'solid-styled-components';
import { palette, theme, fontFamilyAtosBold, fontFamilyAtosRegular } from '../../style/theme';

const { spacing } = theme;

export const StyledEventWrapper = styled.div<{ adjustForHcpHeader: boolean }>`
    container-type: inline-size;
    overflow-x: hidden;
    @media print {
        display: none;
    }

    ${p => p.adjustForHcpHeader ? `
        ${theme.mediaQueries.desktopMin} {
            margin-top: 8rem;
        }
            
        margin-top: 6rem;
    ` : ''}

    ${theme.mediaQueries.mobileMax} {
        margin: 0;
    }
`;

export const StyledEventCardContainer = styled.div``;

export const StyledEventOuter = styled.div<{ fullWidth?: boolean }>`
    ${p => !p.fullWidth ? `
        padding-right: ${spacing.l};
        border-right: 1px solid red;
        ${theme.mediaQueries.tabletMax} {
            padding-right: 0;
            border-right: none;
        }
    ` : ''}
`;

// I put static height so that event card and related events card are aligned horisontally
export const StyledBreadCrumbsWrapper = styled.div`
    color: ${palette.gray};
    font-family: ${fontFamilyAtosRegular};
    font-size: 1.64rem;
    padding-top: 1rem;
    display: flex;
    gap: 0.5rem;
`;

export const StyledLink = styled(Link)`
    height: max-content;
    color: ${palette.gray};
    &:hover {
        color: ${theme.palette.pink};
    }
`;

export const StyledCurrentPage = styled.div`
    color: ${palette.red};
`;

export const StyledEvent = styled.div`
    position: relative;
    background-color: white;
    border-radius: 1.43rem;
    padding: ${spacing.xl} ${spacing.m} ${spacing.ms} ${spacing.m};
    margin: ${spacing.xs} 0;

    ${theme.mediaQueries.mobileMax} {
        padding: ${spacing.s};
    }
`;

export const StyledEventHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: ${spacing.xxxs} ${spacing.m};
    ${theme.mediaQueries.mobileMax} {
        flex-direction: column;
        padding: 0;
    }
`;

export const StyledHeaderContentLeft = styled.div`
    font-family: ${fontFamilyAtosBold};
    font-weight: 800;
    font-size: 1.29rem;
    color: ${theme.palette.darkGray};
    padding-right: 3rem;

    ${theme.mediaQueries.mobileMax} {
        border-bottom: 1px solid ${palette.red};
        padding-bottom: 3rem;
    }

`;

export const StyledHeaderContentRight = styled.div`
    display: flex;
    flex-direction: column;
    font-family: ${fontFamilyAtosBold};
    font-weight: 800;
    font-size: 1.29rem;
    color: ${theme.palette.darkGray};
    gap: 0.5rem;
    padding-left: 3rem;
    text-wrap: nowrap;
    border-left: 1px solid ${palette.red};
    ${theme.mediaQueries.mobileMax} {
        border-left: none;
        padding-top: 3rem;
        padding-left: 0;
    }
`;

export const StyledDate = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
`;

export const StyledLocation = styled.div`
    display: flex;
    flex-direction: row;
    gap: 1rem;
    white-space: normal;
`;

export const StyledText = styled.p`
    margin: 0;
`;

export const StyledAuthor = styled.p`
    margin: 0;
`;


